import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { SceneService } from '../services/scene.service';

@Injectable()

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * Sidebar Guard.
 */
export class SceneGuard implements CanActivate
{
	public constructor(
		private sceneService: SceneService
	)
	{}

	public canActivate(next: ActivatedRouteSnapshot,
				state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean
	{
		return this.sceneService.initalize();
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/guards/scene.guard.ts